var map = {
	"./goldcoin/airdrop-wallet.png": 57096,
	"./memetown/airdrop-wallet.png": 7051,
	"./reflection/airdrop-wallet.png": 52691,
	"./tapcoin/airdrop-wallet.png": 70284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3923;